/* eslint-disable no-unused-expressions */
import { RxSocketUrls } from '@Constants/CommonConstants';
import { StructureFromNameOptions } from '@Pages/StructureEditor/StructureEditorConstants';
import SimpleTmpl from '@Services/SimpleTmpl';
import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';
import UserDatabases from '@Services/UserDatabases';
import SocketBroker from '@Services/SocketBroker';
import keys from 'lodash/keys';
import each from 'lodash/each';
import get from 'lodash/get';
import Auth from '@Services/Auth';

let unregisterErrorsClb;
let unregisterProgressClb;
let searchCompletedPromise;

export const _updateImageWithUrl = (response) => {
  const { substances } = response;
  const token = Auth.getAccessToken();
  if (substances) {
    each(substances, (substance) => {
      // eslint-disable-next-line no-param-reassign
      substance.path = SimpleTmpl.format(
        RequestUrls.relativeResultsImage.url,
        {
          imgPath: get(substance, 'path.url'),
          accessToken: token,
        },
        true
      );
    });
  }
  return response;
};

export const _getMolByHttp = (params) =>
  MessageBroker.send(RequestUrls.structureFromName, params).then(_updateImageWithUrl).catch(Logger.reject);

export const getMolForStructure = (text, option, useHttp) => {
  const user = Auth.getUser();
  const userDbs = user && user.details ? keys(user.details.databases) : null;
  const params = {
    textValue: text,
    option: option || StructureFromNameOptions.IS,
    databases: userDbs || [UserDatabases.getDefaultDatabase()?.id],
  };

  // eslint-disable-next-line no-use-before-define
  return useHttp ? _getMolByHttp(params) : _getMolByWS(params);
};

export const _queryError = (error) => {
  unregisterErrorsClb && unregisterErrorsClb.call(null);
  unregisterProgressClb && unregisterProgressClb.call(null);
  Logger.info('queryError', error);
  searchCompletedPromise.reject(error);
};

export const _processData = (data) => {
  unregisterErrorsClb && unregisterErrorsClb.call(null);
  Logger.info('data', data);
  return _updateImageWithUrl(data.payload);
};

export const _getMolByWS = (payload) => {
  searchCompletedPromise = {};
  searchCompletedPromise.promise = new Promise((resolve, reject) => {
    searchCompletedPromise.resolve = resolve;
    searchCompletedPromise.reject = reject;
  });
  unregisterErrorsClb = SocketBroker.observe(RxSocketUrls.ChannelsUrls.QueueErrors, _queryError);
  const channels = {
    send: RxSocketUrls.ChannelsUrls.gsfn.create,
    message: RxSocketUrls.ChannelsUrls.gsfn.result,
  };

  return new Promise((resolve, reject) => {
    const subject = SocketBroker.send(channels, { params: payload, oneTime: true });
    subject.subscribe({
      next: ({ data }) => resolve(_processData(data)),
      error: reject,
    });
  });
};
